import React from "react";
import PropTypes from "prop-types";
import Button from "../elements/button";
import Icon from "../elements/icon";

/**
 * A basic modal header with a title and an optional cancel button
 * that will only be displayed if a closeModal function is provided.
 * If a custom header is needed in the future, consider creating a seperate component.
 */
const ModalHeader = ({ title, closeModal }) => {
  return (
    <div className="et--modal-header">
      <h3>{title}</h3>
      {closeModal && (
        <Button type="simple" onClick={closeModal}>
          <Icon className="et--modal-confirm--close" icon="close" />
        </Button>
      )}
    </div>
  );
};

ModalHeader.propTypes = {
  title: PropTypes.string.isRequired,
  closeModal: PropTypes.func,
};

export default ModalHeader;
